module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/agenda.json
// module id = 419
// module chunks = 264365852046045